import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ddf6446"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Hero__Subinner" }
const _hoisted_2 = { class: "Hero__Center" }
const _hoisted_3 = {
  key: 0,
  class: "Hero__Mask"
}

import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { Application, Container } from "pixi.js"
import Image from "./Image"
import { canvasSize, getConstants } from "./Config";
import Chapter, { ChapterData } from "./Chapter";
import HeroScrollTrigger from "./HeroScrollTrigger";
import useChapterState from "@/store/modules/useChapterState";

import HeroTitle from "./HeroTitle.vue"
import HeroFrame from "./HeroFrame.vue"
import HeroLoadingProgress from "./HeroLoadingProgress.vue"
import HeroLoadingLight from "./HeroLoadingLight.vue"

import data from "@/store/data"
import Viewport from "@/store/modules/Viewport";

import { gsap, ScrollTrigger, ScrollToPlugin, InertiaPlugin, Draggable } from 'gsap/all';
import Loader from "./Loader";
import useResize from "@/composables/useResize";


export default /*#__PURE__*/_defineComponent({
  __name: 'Hero',
  setup(__props) {

gsap.registerPlugin(InertiaPlugin, ScrollToPlugin, Draggable);

// USE DRAGGABLE TO LISTEN SCROLL AND DRAG


const inner = ref<HTMLDivElement | null>(null)
const canvas = ref<HTMLCanvasElement | null>(null)
const btnLeft = ref<HTMLButtonElement | null>(null)
const btnRight = ref<HTMLButtonElement | null>(null)
const scrollIndicator = ref<HTMLElement | null>(null)
const root = ref<HTMLDivElement | null>(null)
const ruler = ref<HTMLDivElement | null>(null)


const { state, registerGoToNextChapter } = useChapterState();
let draggable = {
  x: 0,
  tickX: null as number | null,
  mouseX: 0,
  previousTickX: null as number | null,
  // velocityX: 0,
  followDragTimeout: null as number | null,
  followDrag: false,
  startAt: null as number | null,
  inertiaTween: null as gsap.core.Tween | null,

  isDragging: false,
  isNavigating: false,
  timelineNavigating: null as gsap.core.Timeline | null,
};
let inertiaProxy: Element|null = null;
let gsapDraggableProxy: Element|null = null;
let gsapDraggable: Draggable | null = null;
let chapters: Array<Chapter> = [];

let scrollTrigger: HeroScrollTrigger | null = null;
  
const createDraggable = () => {
  gsap.ticker.add(tick);

  inertiaProxy = document.createElement('div');
  InertiaPlugin.track(inertiaProxy, 'x');


  gsapDraggableProxy = document.createElement('div');
  gsapDraggable = Draggable.create(gsapDraggableProxy, {
    type: 'x',
    trigger: Viewport.isTouch ? root.value : inner.value,
    bounds: null,
    onPress: Viewport.isTouch ? null : onDragStart,
    onDragStart: Viewport.isTouch ? onDragStart : null,
    onDrag: onDrag,
    onRelease: Viewport.isTouch ? null : onDragEnd,
    onDragEnd: Viewport.isTouch ? onDragEnd : null,
    // onDragEnd: onDragEnd,
    minimumMovement: Viewport.isTouch ? 8 : 2,
    dragClickables: true,
    allowNativeTouchScrolling: true,
  })[0]
}
const destroyDraggable = () => {

  if (gsapDraggable) {
    gsapDraggable.kill();;
  }
  // inner.value.removeEventListener('mousedown', startDrag)
  // inner.value.removeEventListener('touchstart', touchStart)

  // window.removeEventListener('mouseup', endDrag)
  // window.removeEventListener('touchend', touchEnd)

  // inner.value.removeEventListener('mousemove', onMove)
  // inner.value.removeEventListener('touchmove', touchMove)

  gsap.ticker.remove(tick);

  InertiaPlugin.untrack(inertiaProxy, 'x');
}

const onDragStart = () => {
  draggable.previousTickX = draggable.tickX = draggable.mouseX = gsapDraggable.x;

  if (draggable.isNavigating || state.isLoading) {
    return;
  }
  draggable.isDragging = true;

  const wasDragging = state.isListing;
  state.isListing = true;
  state.isGrabbing = true;
  updateChapters();
  if (draggable.inertiaTween) {
    draggable.inertiaTween.kill();
  }

  clearTimeout(draggable.followDragTimeout);
  draggable.followDragTimeout = setTimeout(() => {
    draggable.followDrag = true;
    draggable.previousTickX = draggable.tickX = draggable.mouseX = gsapDraggable.x;
  }, wasDragging ? 0 : 100);
}
const onDrag = () => {
  draggable.mouseX = gsapDraggable.x;
}
const onDragEnd = () => {
      if (!draggable.isDragging) {
        return;
      }
      draggable.isDragging = false

      clearTimeout(draggable.followDragTimeout);

      state.isGrabbing = false;
      draggable.followDrag = false;
      const velocity = InertiaPlugin.getVelocity(inertiaProxy, 'x');
      draggable.inertiaTween = gsap.to(
        draggable,
        {
          inertia: {
            resistance: 5000,
            duration: {
              max: 1
            },
            x: {
              velocity: velocity,
              end: (endValue) => {
                const dragX = setActiveIndex(endValue);

                return Math.floor(dragX);
              }
            },
          },
          onComplete: () => {
            state.isListing = false;
            updateChapters();
            draggable.followDrag = false;
            draggable.startAt = null;
          }
        }
      )
    }

const tick = () => {
  draggable.previousTickX = draggable.tickX;
  draggable.tickX = draggable.mouseX;
  const diffX = draggable.tickX - draggable.previousTickX;

  if (draggable.followDrag) {
    draggable.x += diffX;
    gsap.set(inertiaProxy, { x: draggable.x });
    setActiveIndex(draggable.x);
  }

  if (main) {
    const mainStartY = Viewport.isDesktop ? 55 : 39;
    const scrollProgress = Viewport.isDesktop ? state.scrollProgress : 0;
    main.y = mainStartY - Viewport.windowHeight * scrollProgress * 0.75
  }
}




const setActiveIndex = (x: number): number => {
  const constants = getConstants();
  const step = constants.smallWidth + constants.gap;
  const snapX = Math.round(-x / step);

  const dragX = -snapX * step;

  const nbItem = data.length
  let loopedSnapX = snapX % nbItem + (snapX < 0 ? nbItem : 0);
  if (loopedSnapX === nbItem) {
    loopedSnapX = 0;
  }

  state.activeIndex = loopedSnapX;
  if (state.activeIndex !== state.chapterToLoad) {
    state.chapterToLoad = null;
  }

  return dragX;
}

const goTo = (isNext: boolean) => {
  if (state.isListing) {
    return;
  }

  let nextIndex = isNext ? state.activeIndex + 1 : state.activeIndex - 1;
  if (nextIndex < 0) {
    nextIndex = data.length - 1;
  }
  if (nextIndex >= data.length) {
    nextIndex = 0;
  }
  const nextX = Math.floor(isNext ? 
          draggable.x - (getConstants().smallWidth + getConstants().gap) : 
          draggable.x + (getConstants().smallWidth + getConstants().gap))

  clearTimeout(draggable.followDragTimeout);
  draggable.followDrag = false;
  draggable.isNavigating = true;
  state.isListing = true;
  updateChapters();

  state.chapterToLoad = null;
  
  draggable.timelineNavigating = gsap.timeline({
    onComplete: () => {
      draggable.isNavigating = false;
      state.activeIndex = nextIndex;
      state.isListing = false;
      draggable.timelineNavigating = null;
      updateChapters();
    }
  })
    .to(
      draggable,
      {
        x: nextX,
        duration: 0.5,
        ease: 'quart.inOut',
      },
      0.2
    )
}

const goToNext = () => {
  goTo(true);
}
const goToPrevious = () => {
  goTo(false);
}


const app: Application = new Application()
app.stage.interactiveChildren = false;
let main: Container | null = null;
let loader: Loader | null = null;
const createApplication = async () => {
  measureSizes();

  await app.init({
    canvas: canvas.value!,
    width: canvasSize.width,
    height: canvasSize.height,
    backgroundAlpha: 0,
    // backgroundColor: 0x000000,
    autoDensity: true,
    resolution: window.devicePixelRatio,
    antialias: true,
  })

  main = new Container();


  main.alpha = 0;
  // createTestImage();
  loader = new Loader();
  loader.load(main, chapters);

  app.stage.addChild(loader.container);

  app.stage.addChild(main);

  populateApplication();
}

const populateApplication = () => {
  const { offsetIndex } = canvasSize;

  // CALCULATE NEED CLONE CHAPTERS

  
  
  // BEFORES
  let index = 0;
  for (let i = offsetIndex - 1; i >= 0; i--) {
    const chapter = new Chapter(index++, data[data.length - 1 - i] as ChapterData, state, true);
    main.addChild(chapter.container);

    chapters.push(chapter);
  }

  for (let i = 0; i < data.length; i++) {
  // for (let i = 0; i < 2; i++) {
    const chapter = new Chapter(index++, data[i % data.length] as ChapterData, state, false);
    main.addChild(chapter.container);

    chapters.push(chapter);
  }

  // AFTERS
  // We need as much as clone chapter after than the offsetIndex
  for (let i = 0; i < offsetIndex; i++) {
    const chapter = new Chapter(index++, data[i % (data.length - 1)] as ChapterData, state, true);
    main.addChild(chapter.container);

    chapters.push(chapter);
  }
}

const clearApplication = () => {
  if (main) {
    main.removeChildren();
  }
  chapters = [];
}


const onResize = () => {
  measureSizes();
  app.renderer.resize(canvasSize.width, canvasSize.height);

  destroyDraggable();
  createDraggable();

  clearApplication();
  populateApplication();

  if (state.activeIndex !== 0) {
    goToChapter(state.activeIndex, false);
  }
}

const measureSizes = () => {
  const constants = getConstants();
  const itemSize = constants.smallWidth + constants.gap;

  canvasSize.nbItemInViewport = Math.ceil(Viewport.windowWidth / itemSize);
  canvasSize.offsetIndex = Math.ceil(canvasSize.nbItemInViewport / 2);
  canvasSize.loopSize = data.length * itemSize;
  canvasSize.loopNbItem = data.length;

  canvasSize.width = ruler.value.offsetWidth;
  canvasSize.height = ruler.value.offsetHeight;

  const screenRatio = Viewport.windowHeight / Viewport.windowWidth;

  const bigRatio = (screenRatio < (915/1600)) ? (screenRatio < (800/1600)) ? 0.667 : 0.833 : 1;
  const smallRatio = (screenRatio < (700/375)) ? (screenRatio < (620/375)) ? 0.667 : 0.833 : 1;

  canvasSize.offsetVertical = Viewport.isDesktop ? -100 * bigRatio : -160 * smallRatio;
}



let imageTest: Image|null = null;
const createTestImage = () => {
  const constants = getConstants();
  const { width, height } = {
    width: constants.bigWidth,
    height: constants.bigWidth / constants.ratio.big,
  }

  imageTest = new Image({
    url: "images/hero/chapter-debug@2x.jpg", 
    width, 
    height,
    backgroundSize: "cover",
    crop: false,
  });
  app.stage.addChild(imageTest);
  imageTest.x = (canvasSize.width - width) / 2;
  imageTest.y = (canvasSize.height - height) / 2;

  imageTest.alpha = 0.5;
}
const resizeTestImage = () => {
  if (imageTest) {
    const constants = getConstants();
    const { width, height } = {
      width: constants.bigWidth,
      height: constants.bigWidth / constants.ratio.big,
    }
    imageTest.updateSize(width, height);
    imageTest.x = (canvasSize.width - width) / 2;
    imageTest.y = (canvasSize.height - height) / 2;
  }
}

const { registerResize, unregisterResize } = useResize();

onMounted(() => {
  createDraggable();
  createApplication();
  scrollTrigger = new HeroScrollTrigger(root.value, btnLeft.value, btnRight.value, scrollIndicator.value, state);



  registerResize(onResize, true);


  gsap.ticker.add(() => {
    chapters.forEach((chapter) => {
      chapter.tick(state, draggable.x);
    })
  })
  if (state.activeIndex !== 0) {
    goToChapter(state.activeIndex, false);
  }
})
onBeforeUnmount(() => {
  destroyDraggable();
  scrollTrigger.destroy();

  unregisterResize();
  app.destroy();
});


// watch(() => state.isListing, () => {
//   chapters.forEach((chapter) => {
//     chapter.update(state);
//   })
// })


const updateChapters = (instant: boolean = false) => {
  chapters.forEach((chapter) => {
    chapter.update(state, instant);
  })
}

const goToChapter = (index: number, instant: boolean, onComplete: () => void = () => {}): void => {
  const previousIndex = index - 1;
  const previousDraggableX = draggable.x;
  
  state.chapterToLoad = null;
  state.activeIndex = index;
  draggable.x = -state.activeIndex * (getConstants().smallWidth + getConstants().gap);
  
  const timeline = gsap.timeline({
    onComplete
  });
  state.isListing = true;

  chapters.forEach((chapter) => {
    chapter.update(state, true);
    chapter.tick(state, draggable.x);
  })
  timeline.add(() => {
    state.isListing = false;
    updateChapters();
    scrollTrigger?.refresh();
  }, instant ? 0 : 0.7)
}

registerGoToNextChapter((): void => {
  const { activeIndex } = state;

  goToChapter(
    (activeIndex + 1) % data.length, 
    false, 
    () => {
      ScrollTrigger.refresh();
    }
  );
})


let chapterToLoadTimeout: number | null = null;
watch(() => state.isListing, (value, previous) => {
  if (value && !previous) {
    clearTimeout(chapterToLoadTimeout);
    // console.log('[Hero] go to listing');
    // state.chapterToLoad = null;
  } else if (!value && previous) {
    clearTimeout(chapterToLoadTimeout);
    chapterToLoadTimeout = setTimeout(() => {
      // console.log('[Hero] no more listing');
      state.chapterToLoad = state.activeIndex;
    }, 600)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "Hero",
    ref_key: "root",
    ref: root
  }, [
    _createElementVNode("div", {
      class: "Hero__Ruler",
      ref_key: "ruler",
      ref: ruler
    }, null, 512),
    _createElementVNode("div", {
      class: _normalizeClass(["Hero__Inner SectionPadding", { 'is-dragging': _unref(state).isGrabbing, 'is-loading': _unref(state).isLoading }]),
      ref_key: "inner",
      ref: inner
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(HeroLoadingLight),
          _createElementVNode("canvas", {
            class: "Hero__Canvas",
            ref_key: "canvas",
            ref: canvas
          }, null, 512),
          (!_unref(state).isLoading)
            ? (_openBlock(), _createBlock(HeroFrame, {
                key: 0,
                show: _unref(state).isListing
              }, null, 8, ["show"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (chapter, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(HeroTitle, {
                title: _ctx.$t(chapter.hero.title),
                show: index === (_unref(state).activeIndex % _unref(data).length) && !_unref(state).isListing && !_unref(state).isLoading
              }, null, 8, ["title", "show"])
            ]))
          }), 128))
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["Hero__Scroller", { 'show': !_unref(state).isListing && !_unref(state).isLoading }])
        }, [
          _createElementVNode("span", {
            ref_key: "scrollIndicator",
            ref: scrollIndicator
          }, _toDisplayString(_ctx.$t('hero.scroller')), 513)
        ], 2)
      ]),
      (!_unref(state).isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(HeroLoadingProgress),
    _createElementVNode("div", {
      class: _normalizeClass(["Hero__Navigation grid", { 'show': !_unref(state).isListing && _unref(state).showNavigation }])
    }, [
      _createElementVNode("button", {
        ref_key: "btnLeft",
        ref: btnLeft,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPrevious())),
        class: "Hero__Navigation__Btn Hero__Navigation__Btn--Left SectionPadding"
      }, null, 512),
      _createElementVNode("button", {
        ref_key: "btnRight",
        ref: btnRight,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (goToNext())),
        class: "Hero__Navigation__Btn Hero__Navigation__Btn--Right SectionPadding"
      }, null, 512)
    ], 2)
  ], 512))
}
}

})